import AuthService from "./AuthService";

//const API_URL = "http://localhost:8081/api/users/";
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8081";
const API_URL = `${API_BASE_URL}/api/users/`;
class UserService {
  async handleResponse(response) {
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! Status: ${response.status}, Message: ${errorText}`);
    }

    const contentType = response.headers.get("Content-Type");
    if (!contentType || !contentType.includes("application/json")) {
      if (response.status === 204 || response.status === 200) return null;
      throw new Error("Server nije vratio JSON odgovor");
    }

    return await response.json();
  }

  // DODATA METODA KOJA JE NEDOSTAJALA:
  // GET: http://localhost:8081/api/users/user/{id}
  async getUserById(id) {
    try {
      const response = await fetch(`${API_URL}user/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...AuthService.getAuthHeader(),
        },
      });
      return await this.handleResponse(response);
    } catch (error) {
      console.error("Error fetching user by ID:", error);
      throw error;
    }
  }

  async getAllStaff() {
    try {
      const response = await fetch(`${API_URL}staff`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...AuthService.getAuthHeader(),
        },
      });
      return await this.handleResponse(response);
    } catch (error) {
      console.error("Error fetching staff:", error);
      throw error;
    }
  }

  async createUser(userData) {
    try {
      const response = await fetch(`${API_URL}user`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...AuthService.getAuthHeader(),
        },
        body: JSON.stringify(userData),
      });
      return await this.handleResponse(response);
    } catch (error) {
      console.error("Error creating user:", error);
      throw error;
    }
  }

  async updateUser(userId, userData) {
    try {
      const response = await fetch(`${API_URL}user/${userId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          ...AuthService.getAuthHeader(),
        },
        body: JSON.stringify(userData),
      });
      return await this.handleResponse(response);
    } catch (error) {
      console.error("Error updating user:", error);
      throw error;
    }
  }

  async getUserByDoctorId(doctorId) {
    try {
      const response = await fetch(`${API_URL}user/doctor/${doctorId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...AuthService.getAuthHeader(),
        },
      });
      return await this.handleResponse(response);
    } catch (error) {
      console.error("Error fetching user by doctor ID:", error);
      throw error;
    }
  }

  async deleteUser(userId) {
    try {
      const response = await fetch(`${API_URL}user/${userId}`, {
        method: "DELETE",
        headers: {
          ...AuthService.getAuthHeader(),
        },
      });
      return await this.handleResponse(response);
    } catch (error) {
      console.error("Error deleting user:", error);
      throw error;
    }
  }
}

export default new UserService();